import { Palette, Theme, alpha } from '@mui/material'

export const theme = (func: (theme: Theme) => string | number): ((props: any) => string | number) => {
    return (props) => func(props.theme)
}

export const spacing = (spacing: number): ((props: any) => string) => {
    return (props) => props.theme.spacing(spacing)
}

export const palette = (func: (palette: Palette) => string): ((props: any) => string) => {
    return (props) => func(props.theme.palette)
}

/** Soft neutral border — light gray in light mode, subtle in dark mode */
export const subtleBorder =
    (opacity = 0.1) =>
    (props: { theme: Theme }) =>
        alpha(props.theme.palette.common.black, opacity)
